import { render } from "./AdminLayout.vue?vue&type=template&id=0c87b52c"
import script from "./AdminLayout.vue?vue&type=script&lang=js"
export * from "./AdminLayout.vue?vue&type=script&lang=js"

import "./AdminLayout.vue?vue&type=style&index=0&id=0c87b52c&lang=scss"

import exportComponent from "/home/runner/work/dalmatian2.reunionmarketing.com/dalmatian2.reunionmarketing.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__